import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  storage;
  constructor() {
    this.storage = localStorage;
  }

  public setStorage(key: string, value: any) {
    return this.storage.setItem(key, value);
  }

  public getStorage(key: string) {
    return this.storage.getItem(key);
  }

  public clearStorage() {
    return this.storage.clear();
  }

  public removeStorage(key: string) {
    return this.storage.removeItem(key);
  }


}
